import styled from 'styled-components'
import PropTypes from 'prop-types'

const Card = styled.div`
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 2.4rem;
  margin-bottom: ${props => props.marginBottom ? `${props.marginBottom}px` : '0'};
  margin-top: ${props => props.marginTop ? `${props.marginTop}px` : '0'};
  position: relative;
  background: var(--the-white);
  gap: 16px;
  ${props => props.padding ? `padding: ${props.padding};` : 'padding: 24px;'}
  ${props => props.width ? `width: ${props.width};` : 'width: 100%;'}
  ${props => props.selected ? 'border: 2px solid var(--cobasi-blue-light-9);' : 'border: 1px solid var(--silver);'}
  ${props => props.height ? `height: ${props.height}px;` : 'height: fit-content;'}
  ${props => !props.active && 'pointer-events: none; opacity: 0.4;'}

  @media screen and (max-width: 1200px) {
    ${props => props.padding ? `padding: ${props.padding};` : 'padding: 24px;'}
  }
`
export default Card

Card.propTypes = {
  children: PropTypes.node,
  marginBottom: PropTypes.number,
  width: PropTypes.string,
  height: PropTypes.number,
  active: PropTypes.bool
}
